export default {
    patientList: "Patient list",
  };
  